import { BlockHeading } from "components/landing-pages/BlockHeading";
import { ImageTextBlock } from "dtos/content/landing-pages/ImageTextBlock";

export const ImageTextBlockDisplay = (props: { block: ImageTextBlock }) => {
    const { block } = props;
    const { heading, imageUrl, imageSide, content, actionText, actionUrl, actionNewTab } = block;

    const imageClass = imageSide === "left" ? "order-lg-2" : "order-lg-3";
    const contentClass = imageSide === "left" ? "order-lg-3" : "order-lg-2";

    return (
        <div className="grid">
            {heading && (
                <div className="g-col-12 order-0">
                    <BlockHeading block={block} />
                </div>
            )}

            <div className={`g-col-12 g-col-lg-6 order-2 align-self-center ${imageClass}`}>
                <img src={imageUrl} alt={heading} className="img-fluid" />
            </div>

            <div className={`g-col-12 g-col-lg-6 order-3 align-self-center ${contentClass}`}>
                <div className="vstack gap-4">
                    <div className="content-block vstack gap-4" dangerouslySetInnerHTML={{ __html: content }}></div>

                    {actionText && actionUrl && (
                        <div>
                            <a className="btn btn-primary" href={actionUrl} target={actionNewTab ? "_blank" : "_self"}>
                                {actionText}
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
